<template>

  <div class="AboutPage">
    <div class="about-banner">
      <div class="box">
        <div class="banner-content center">
          <h1>{{ banner.title }}</h1>
          <br>
          <p>{{ banner.subtitle }}</p>
          <div class="banner-features">
            <span v-for="(feature, index) in parsedBannerFeatures" :key="index">{{ feature.normal_text }}</span>
          </div>
        </div>
      </div>
    </div>
    <sticky-nav :nav-items="navItems" class="sticky-nav-desktop" />


    <div id="company-intro" class="company-intro Pt75">
      <div class="box">
        <div class="PubTitle center">
          <h2>{{ intro.title }}</h2>
          <br>
          <p>{{ intro.subtitle }}</p>
        </div>
        <div class="flex between intro-main">
          <div class="intro-img">
            <img :src="intro.image_path" :alt="intro.title" style="max-width: 100%"/>
            <div class="intro-overlay">
              <div class="company-stats">
                <div v-for="(value, key) in intro.stats" :key="key" class="stat-item">
                  <span class="stat-number">{{ value }}</span>
                  <span class="stat-label">{{ key }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="intro-content">
            <div class="intro-text" v-html="intro.content"></div>
            <div class="intro-action">
              <router-link to="/contact" active-class="active">
                <a href="#" class="PubMore" @click="showCompanyVideo">
                  <i>了解更多</i>
                  <img src="/images/u16.svg" alt=""/>
                </a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    <div class="rd-strength Pt75 BgGray">
          <div class="box">
            <div class="PubTitle center">
              <h2>{{ rd.title }}</h2>
              <br>
              <p>{{ rd.subtitle }}</p>
            </div>
            <div class="rd-description">
              <p v-html="rd.content"></p>
            </div>
            <div class="rd-stats">
              <div class="stats-grid">
                <div v-for="(stat, index) in rdStats" :key="index" class="stat-card">
                  <div class="stat-content">
                    <span class="stat-number">{{ stat.number }}</span>
                    <span class="stat-label">{{ stat.label }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="rd-features">
              <div class="feature-grid">
                <div v-for="(feature, index) in rdFeatures" :key="index" class="feature-item">
                  <div class="feature-icon">
                    <img :src="feature.icon" :alt="feature.title"/>
                  </div>
                  <h4>{{ feature.title }}</h4>
                  <p>{{ feature.description }}</p>
                </div>
              </div>
            </div>

          </div>
        </div>-->

    <div id="company-timeline" class="company-timeline Pt75">
      <div class="box">
        <div class="PubTitle center">
          <h2>{{ timeline.title }}</h2>
          <br>
          <p>{{ timeline.subtitle }}</p>
        </div>
        <div class="timeline-container">
          <div class="timeline-line"></div>
          <div v-for="(milestone, index) in milestones" :key="index" class="timeline-item" :class="{
            'timeline-left': index % 2 === 0,
            'timeline-right': index % 2 === 1,
            'animate-in': true
          }" :style="{ animationDelay: (index * 0.2) + 's' }">
            <div class="timeline-dot">
              <div class="timeline-year">{{ milestone.year }}</div>
            </div>
            <div class="timeline-content">
              <div class="timeline-card">
                <h3>{{ milestone.title }}</h3>
                <div v-html="isMobile ? milestone.description_phone : milestone.description" class="application-list"></div>
                <br>
                <!-- 添加图片展示 -->
                <img v-if="milestone.icon_url" :src="milestone.icon_url" alt="Milestone Icon" style="max-width: 100%; margin-bottom: 15px;">
                <div class="timeline-achievements" v-if="milestone.achievements">
                  <span v-for="(achievement, idx) in milestone.achievements" :key="idx" class="achievement-tag">
                    {{ achievement }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="company-honors" class="company-honors Pt75 BgGray">
      <div class="box">
        <div class="PubTitle center">
          <h2>{{ honorsData.title }}</h2>
          <br>
          <p>{{ honorsData.subtitle }}</p>
        </div>
        <div class="honors-container">
          <div class="honors-grid">
            <div v-for="(honor, index) in honors" :key="index" class="honor-item">
              <div class="honor-image">
                <img :src="honor.image_img" :alt="honor.title"/>
                <div class="honor-overlay">
                  <div class="honor-info">
                    <h4>{{ honor.title }}</h4>
                    <p>{{ honor.description }}</p>
                    <span class="honor-year">{{ honor.year }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="sales-network" class="sales-network Pt75">
      <div class="box">
        <div class="PubTitle center">
          <h2>{{ sales_network.title }}</h2>
          <br>
          <p>{{ sales_network.subtitle }}</p>
        </div>
        <div class="network-container">
          <div class="network-map">
            <div class="map-container">
              <img :src="sales_network.image_path" alt="全球销售网络"/>
              <div class="network-points">
                <div v-for="(point, index) in networkPoints" :key="index" class="network-point"
                     :style="{ left: point.x + '%', top: point.y + '%' }">
                  <div class="point-marker"></div>
                  <div class="point-info">
                    <h5>{{ point.region }}</h5>
                    <p>{{ point.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="network-stats">
            <div class="stats-row">
              <div v-for="(stat, index) in networkStats" :key="index" class="network-stat">
                <!--                <div class="stat-icon">-->
                <!--                  -->
                <!--                </div>-->
                <div class="stat-info">
                  <span class="stat-number">{{ stat.number }}</span>
                  <span class="stat-label">{{ stat.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    <div class="company-culture Pt75 BgGray">
          <div class="box">
            <div class="PubTitle center">
              <h2>{{ culture.title }}</h2>
              <br>
              <p>{{ culture.subtitle }}</p>
            </div>
            <div class="culture-container">
              <div class="culture-grid">
                <div v-for="(culture, index) in cultureValues" :key="index" class="culture-item">
                  <div class="culture-icon">
                    <img :src="culture.icon_url" />
                  </div>
                  <div class="culture-content">
                    <h3>{{ culture.title }}</h3>
                    <p>{{ culture.description }}</p>
                    <div class="culture-details">
                      <ul>
                        <li v-for="(detail, idx) in culture.details" :key="idx">{{ detail }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

    <div id="company-vision" class="company-vision Pt75">
      <div class="box">
        <div class="PubTitle center">
          <h2>{{ vision.title }}</h2>
          <br>
          <p>{{ vision.subtitle }}</p>
        </div>
        <div class="vision-content">
          <div class="vision-main">
            <div class="vision-text" v-html="vision.content"></div>
            <div class="vision-image">
              <img :src="vision.image_path" alt="未来愿景"/>
            </div>
          </div>
          <!--          <div class="vision-goals-section">
                      <div class="goals-container">
                        <div class="goals-header">
                          <h3>发展目标</h3>
                          <p>2025-2030年战略规划</p>
                        </div>
                        <div class="goals-grid">
                          <div v-for="(goal, index) in visionGoals" :key="index" class="goal-item">
                            <div class="goal-icon">
                              <img :src="goal.image_path" />
                            </div>
                            <div class="goal-content">
                              <h4>{{ goal.title }}</h4>
                              <p>{{ goal.description }}</p>
                              <div class="goal-timeline">
                                <span>{{ goal.timeline }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StickyNav from '@/components/StickyNav.vue';
import {
  getProfileSection,
  getProfileRdItem,
  getProfileMilestone,
  getProfileHonor,
  getProfileNetworkItem,
  getProfileCultureValue,
  getProfileVisionGoal,
  getPageHeader
} from '@/api/request.js';

export default {
  name: 'AboutPage',
  components: {
    StickyNav
  },
  data() {
    return {
      banner: {},
      intro: {},
      rd: {},
      timeline: {},
      honorsData: {},
      sales_network: {},
      culture: {},
      vision: {},
      rdStats: [],
      rdFeatures: [],
      milestones: [],
      honors: [],
      networkPoints: [],
      networkStats: [],
      cultureValues: [],
      visionGoals: [],
      navItems: [],
      isMobile: false
    };
  },
  computed: {
    parsedBannerFeatures() {
      try {
        return this.banner.features ? JSON.parse(this.banner.features) : [];
      } catch (error) {
        console.error('Error parsing banner features:', error);
        return [];
      }
    }
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.checkIsMobile();
    window.addEventListener('resize', this.checkIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkIsMobile);
  },
  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    async fetchData() {
      try {
        const responses = await Promise.all([
          getProfileSection(),
          getProfileRdItem(),
          getProfileMilestone({"pageSize":300}),
          getProfileHonor(),
          getProfileNetworkItem(),
          getProfileCultureValue(),
          getProfileVisionGoal(),
          getPageHeader({ title: '关于Waykar' })
        ]);

        const sections = responses[0].list.reduce((acc, item) => {
          acc[item.section_key] = {
            ...item,
            stats: item.stats ?? []
          };
          return acc;
        }, {});
        console.log(1111111111111111111111111222222, sections, 2222222222)
        this.intro = sections.intro || {};
        this.rd = sections.rd || {};
        this.timeline = sections.timeline || {};
        this.sales_network = sections.sales_network || {};
        console.log(this.sales_network)
        this.culture = sections.culture || {};
        this.vision = sections.vision || {};
        this.honorsData = sections.honors || {};

        this.updateNavItems();

        const rdItems = responses[1].list;
        this.rdStats = rdItems.filter(item => item.item_type === 'stat').map(item => ({ number: item.value, label: item.title, icon: item.icon }));
        this.rdFeatures = rdItems.filter(item => item.item_type === 'feature').map(item => ({ icon: item.icon_url, title: item.title, description: item.description }));

        // 修改：移除 JSON.parse 并增加类型保护
        this.milestones = responses[2].list.map(item => ({
          ...item,
          achievements: Array.isArray(item.achievements)
              ? item.achievements
              : []
        }));
        this.honors = responses[3].list.map(item => ({ ...item, image: item.image_url }));

        const networkItems = responses[4].list;
        this.networkPoints = networkItems.filter(item => item.item_type === 'point').map(item => ({ region: item.title, description: item.description, x: item.pos_x, y: item.pos_y }));
        this.networkStats = networkItems.filter(item => item.item_type === 'stat').map(item => ({ number: item.value, label: item.title, icon: item.icon }));

        this.cultureValues = responses[5].list.map(item => ({
          ...item,
          details: Array.isArray(item.details)
              ? item.details
              : []
        }));
        this.visionGoals = responses[6].list;

        if (responses[7].list.length > 0) {
          this.banner = responses[7].list[0];
        } else {
          this.banner = {};
        }

      } catch (error) {
        console.error('Error fetching about page data:', error);
      }
    },
    updateNavItems() {
      this.navItems = [
        { id: 'company-intro', title: this.intro.title },
        { id: 'company-timeline', title: this.timeline.title },
        { id: 'company-honors', title: this.honorsData.title },
        { id: 'sales-network', title: this.sales_network.title },
        { id: 'company-vision', title: this.vision.title }
      ].filter(item => item.title);
    },
    showCompanyVideo() {
      console.log('显示公司介绍视频');
    }
  }
};
</script>
<style>
/* 页面横幅样式 */
.about-banner {
  background: #47975a;
  color: white;
  padding: 100px 0;
  margin-bottom: 0;
  position: relative;
  overflow: hidden;
}

.AboutPage svg {
  color: white;
}

.about-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: none;
  background-size: cover;
  opacity: 0.1;
}

.banner-content {
  position: relative;
  z-index: 2;
}

.banner-content h1 {
  font-size: 56px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.banner-content > p {
  font-size: 24px;
  opacity: 0.95;
  margin-bottom: 30px;
}

.banner-features {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 40px;
}

.banner-features span {
  background: rgba(255, 255, 255, 0.2);
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.banner-features span:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* 公司介绍样式 */
.intro-main {
  align-items: flex-start;
  gap: 60px;
  margin-top: 50px;
}

.intro-img {
  flex: 1;
  position: relative;
}

.intro-img img {
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.intro-img:hover img {
  transform: scale(1.02);
}

.intro-overlay {
  display: none;
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.95);
  padding: 20px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.company-stats {
  display: flex;
  justify-content: space-around;
}

.company-stats .stat-item {
  text-align: center;
}

.company-stats .stat-number {
  display: block;
  font-size: 24px;
  font-weight: bold;
  color: #47975a;
  margin-bottom: 5px;
}

.company-stats .stat-label {
  font-size: 14px;
  color: #666;
}

.intro-content {
  flex: 1;
}

.intro-text {
  font-size: 20px;
}

.intro-text h3 {
  font-size: 28px;
  color: #47975a;
  margin-bottom: 20px;
  font-weight: bold;
}

.intro-text p {
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 20px;
  color: #666;
}

.intro-text strong {
  color: #47975a;
  font-weight: 600;
}

.intro-action {
  margin-top: 40px;
}

.intro-action .PubMore {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #47975a;
  color: white;
  padding: 15px 30px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(71, 151, 90, 0.3);
}

.intro-action .PubMore:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(71, 151, 90, 0.4);
}

.intro-action .PubMore img {
  width: 16px;
  filter: brightness(0) invert(1);
}

/* 研发实力样式 */
.rd-description p {
  font-size: 18px;
  line-height: 1.8;
  color: #666;
  text-align: center;
  margin-bottom: 50px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.stat-card {
  background: white;
  padding: 30px 20px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border-color: #47975a;
}

.stat-icon {
  width: 60px;
  height: 60px;
  background: #47975a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.stat-icon i {
  font-size: 24px;
  color: white;
}

.stat-content .stat-number {
  display: block;
  font-size: 32px;
  font-weight: bold;
  color: #47975a;
  margin-bottom: 8px;
}

.stat-content .stat-label {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.feature-item {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  text-align: center;
  transition: all 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.feature-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  border-radius: 50%;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-icon img {
  width: 40px;
  height: 40px;
}

.feature-item h4 {
  font-size: 20px;
  color: #47975a;
  margin-bottom: 15px;
  font-weight: 600;
}

.feature-item p {
  color: #666;
  line-height: 1.6;
}

/* 时光隧道样式 */
.timeline-container {
  position: relative;
  max-width: 1300px;
  margin: 50px auto 0;
  padding: 0 20px;
}

.timeline-line {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #47975a;
  transform: translateX(-50%);
  border-radius: 2px;
}

.timeline-item {
  position: relative;
  margin-bottom: 60px;
  opacity: 0;
  animation: fadeInUp 0.6s ease forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.timeline-left {
  padding-right: 50%;
  text-align: right;
}

.timeline-right {
  padding-left: 50%;
  text-align: left;
}

.timeline-dot {
  position: absolute;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
  z-index: 2;
}

.timeline-year {
  background: #47975a;
  color: white;
  padding: 12px 20px;
  border-radius: 30px;
  font-weight: bold;
  font-size: 16px;
  box-shadow: 0 5px 15px rgba(71, 151, 90, 0.3);
  border: 4px solid white;
}

.timeline-content {
  position: relative;
  margin-right: 60px;
}

.timeline-right .timeline-content {
  margin-right: 0;
  margin-left: 60px;
}

.timeline-card {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 2px solid transparent;
  position: relative;
}

.timeline-card::before {
  content: '';
  position: absolute;
  top: 30px;
  width: 0;
  height: 0;
  border: 15px solid transparent;
}

.timeline-left .timeline-card::before {
  right: -30px;
  border-left-color: white;
}

.timeline-right .timeline-card::before {
  left: -30px;
  border-right-color: white;
}

.timeline-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border-color: #47975a;
}

.timeline-icon {
  width: 50px;
  height: 50px;
  background: #47975a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.timeline-left .timeline-icon {
  margin-left: auto;
}

.timeline-icon i {
  font-size: 20px;
  color: white;
}

.timeline-card h3 {
  color: #47975a;
  margin-bottom: 15px;
  font-size: 22px;
  font-weight: 600;
}

.timeline-card p {
  color: #666;
  line-height: 1.7;
  margin-bottom: 20px;
}

.timeline-achievements {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.achievement-tag {
  background: #f0f8f4;
  color: #47975a;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #e0f2e7;
}

/* 荣誉证书样式 */
.honors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(245px, 1fr));
  gap: 30px;
  margin-top: 50px;
}

.honor-item {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.honor-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.honor-image {
  position: relative;
  height: 250px;
  overflow: hidden;
}

.honor-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.honor-item:hover .honor-image img {
  transform: scale(1.05);
}

.honor-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  padding: 30px 20px 20px;
  color: white;
}

.honor-info h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}

.honor-info p {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 10px;
}

.honor-year {
  background: #47975a;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

/* 销售网络样式 */
.network-container {
  margin-top: 50px;
}

.map-container {
  position: relative;
  background: #f8f9fa;
  border-radius: 16px;
  padding: 40px;
  margin-bottom: 50px;
}

.map-container img {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  display: block;
  opacity: 0.8;
}

.network-points {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.network-point {
  position: absolute;
  cursor: pointer;
}

.point-marker {
  width: 20px;
  height: 20px;
  background: #47975a;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 2px 10px rgba(71, 151, 90, 0.5);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(71, 151, 90, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(71, 151, 90, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(71, 151, 90, 0);
  }
}

.point-info {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 15px 20px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  text-align: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.network-point:hover .point-info {
  opacity: 1;
  visibility: visible;
}

.point-info h5 {
  color: #47975a;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
}

.point-info p {
  color: #666;
  font-size: 12px;
}

.stats-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
}

.network-stat {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  text-align: center;
  transition: all 0.3s ease;
}

.network-stat:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.network-stat .stat-icon {
  width: 60px;
  height: 60px;
  background: #47975a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.network-stat .stat-icon i {
  font-size: 24px;
  color: white;
}

.network-stat .stat-number {
  display: block;
  font-size: 28px;
  font-weight: bold;
  color: #47975a;
  margin-bottom: 8px;
}

.network-stat .stat-label {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}

/* 企业文化样式 */
.culture-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-top: 50px;
}

.culture-item {
  background: white;
  padding: 40px 30px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.culture-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
  border-color: #47975a;
}

.culture-icon {
  width: 80px;
  height: 80px;
  background: #47975a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
}

.culture-icon i {
  font-size: 32px;
  color: white;
}

.culture-content h3 {
  color: #47975a;
  margin-bottom: 15px;
  font-size: 24px;
  font-weight: 600;
}

.culture-content p {
  color: #666;
  line-height: 1.7;
  margin-bottom: 20px;
}

.culture-details ul {
  list-style: none;
  padding: 0;
}

.culture-details li {
  color: #666;
  padding: 8px 0;
  padding-left: 20px;
  position: relative;
  font-size: 14px;
}

.culture-details li::before {
  content: '•';
  color: #47975a;
  font-weight: bold;
  position: absolute;
  left: 0;
}

/* 未来愿景样式 */
.vision-content {
  margin-top: 50px;
}

.vision-main {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 60px;
  align-items: center;
  margin-bottom: 80px;
}

.vision-text h3 {
  font-size: 32px;
  color: #47975a;
  margin-bottom: 25px;
  font-weight: bold;
}

.vision-text p {
  font-size: 18px;
  line-height: 1.8;
  color: #666;
  margin-bottom: 25px;
}

.vision-image {
  position: relative;
}

.vision-image img {
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.vision-goals-section {
  background: #47975a;
  padding: 60px 40px;
  border-radius: 20px;
  margin-top: 50px;
}

.goals-header {
  text-align: center;
  margin-bottom: 50px;
}

.goals-header h3 {
  font-size: 32px;
  color: #47975a;
  margin-bottom: 15px;
  font-weight: bold;
}

.goals-header p {
  font-size: 18px;
  color: #666;
}

.goals-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.goal-item {
  background: white;
  padding: 40px 30px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 2px solid transparent;
  text-align: center;
}

.goal-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
  border-color: #47975a;
}

.goal-icon {
  width: 80px;
  height: 80px;
  background: #47975a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
}

.goal-icon i {
  font-size: 32px;
  color: white;
}

.goal-content h4 {
  font-size: 22px;
  color: #47975a;
  margin-bottom: 15px;
  font-weight: 600;
}

.goal-content p {
  color: #666;
  line-height: 1.7;
  margin-bottom: 20px;
}

.goal-timeline {
  background: #f0f8f4;
  color: #47975a;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .banner-content h1 {
    font-size: 36px;
  }

  .banner-content > p {
    font-size: 18px;
  }

  .banner-features {
    flex-direction: unset;
    gap: 15px;
    align-items: center;
  }

  .banner-features span {
    padding: 10px 20px;
    font-size: 14px;
  }

  .intro-main {
    flex-direction: column;
    gap: 40px;
  }

  .intro-overlay {
    display: none;
    position: static;
    margin-top: 20px;
  }

  .intro-text h3 {
    font-size: 24px;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .feature-grid {
    grid-template-columns: 1fr;
  }

  .timeline-container {
    padding: 0 8px;
  }

  .timeline-line {
    display: none;
  }

  .timeline-left,
  .timeline-right {
    padding: 0;
    text-align: center;
  }

  .timeline-content {
    margin: 0;
  }

  .timeline-card::before {
    display: none;
  }

  .timeline-dot {
    position: static;
    transform: none;
    margin-bottom: 20px;
  }

  .honors-grid {
    grid-template-columns: 1fr;
  }

  .map-container {
    padding: 20px;
  }

  .stats-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .culture-grid {
    grid-template-columns: 1fr;
  }

  .vision-main {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .vision-goals-section {
    padding: 40px 20px;
  }

  .goals-grid {
    grid-template-columns: 1fr;
  }

  .goals-header h3 {
    font-size: 28px;
  }

  .vision-text h3 {
    font-size: 28px;
  }

  .vision-text p {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .banner-content h1 {
    font-size: 28px;
  }

  .banner-content > p {
    font-size: 16px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stats-row {
    grid-template-columns: 1fr;
  }

  .timeline-year {
    padding: 10px 16px;
    font-size: 14px;
  }

  .timeline-card {
    padding: 14px;
  }

  .timeline-card h3 {
    font-size: 18px;
  }

  .honor-image {
    height: 200px;
  }

  .culture-item {
    padding: 30px 20px;
  }

  .goal-item {
    padding: 30px 20px;
  }

  .vision-goals-section {
    padding: 30px 15px;
  }
}

/* 在媒体查询中添加移动端隐藏 sticky-nav 的样式 */
.sticky-nav-desktop {
  display: block;
}

@media (max-width: 768px) {
  .sticky-nav-desktop {
    display: none;
  }
}
</style>